import { invariant } from '../util/invariant';

/**
 * This helper class is meant to provide an iterator for the
 * sample durations that are represented in a compact way
 * inside a stts mp4 box.
 */
export class SampleDurationHelper {

  private i = 0;
  private j = 0;

  constructor(
    private sample_counts: number[],
    private sample_deltas: number[],
  ) {
    invariant(sample_counts.length === sample_deltas.length, 'sample_counts and sample_deltas should have the same length');
  }


  getNextSampleDuration(): number {
    if (this.sample_counts.length === 0) {
      // Let's default to 1024 since it is the AAC default duration
      return 1024;
    }

    const offset = this.sample_deltas[this.i];

    this.j++;
    if (this.j === this.sample_counts[this.i]) {
      this.i++;
      this.j = 0;
    }
    return offset;
  }
}
